import { NgModule } from '@angular/core'
import { ChooseSportComponent } from './choose-sport.component'
import { CommonModule } from '@angular/common'
import { AnalyticsModule } from 'src/app/shared/analytics/analytics.module'

@NgModule({
  declarations: [ChooseSportComponent],
  imports: [CommonModule, AnalyticsModule],
  exports: [ChooseSportComponent]
})
export class ChooseSportComponentModule {}
